module.exports = __webpack_public_path__ + "static/media/crfCardsAssetsCashAdvance.97526ba1.svg";